import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '../components/Layout/Layout';
import { UserList } from '../components/UseList';
import { UserReportsPage } from './users/UserReportsPage';
import Heading from '../components/heading';

export default function UsersPage() {
  return (
    <Layout>
      <Routes>
        <Route index element={
          <>
            <Heading text="All Users" />
            <UserList />
          </>
        } />
        <Route path="reports" element={<UserReportsPage />} />
        <Route path="*" element={<Navigate to="/users" replace />} />
      </Routes>
    </Layout>
  );
}